import Section from "../../../parts/Section";
import { Category } from "../../../types";

const EquipmentList = ({
  blocked,
  category,
  onChangeBlocked,
  onClearCategory,
}: {
  blocked: boolean;
  category: Category | null;
  onChangeBlocked: (blocked: boolean) => () => void;
  onClearCategory: () => void;
}) => {
  return (
    <Section className="px-4 mt-4 flex gap-2">
      {!blocked && (
        <span
          className="rounded-full bg-green-100 text-green-700 text-xs py-1 px-3 uppercase font-mono cursor-pointer"
          onClick={onChangeBlocked(true)}
        >
          Disponíveis
        </span>
      )}

      {blocked && (
        <span
          className="rounded-full bg-red-100 text-red-700 text-xs py-1 px-3 uppercase font-mono cursor-pointer"
          onClick={onChangeBlocked(false)}
        >
          Bloqueados
        </span>
      )}

      {category && (
        <span
          className="rounded-full bg-neutral-100 text-neutral-700 text-xs py-1 px-3 uppercase font-mono cursor-pointer"
          onClick={onClearCategory}
        >
          {category.name} ✕
        </span>
      )}
    </Section>
  );
};

export default EquipmentList;
